import React from 'react';
import CountCard from './countCard';

const countData = [
  { endValue: 120, label: 'Happy Customers', isPercentage: false },
  { endValue: 120, label: 'Projects Done', isPercentage: false },
  { endValue: 70, label: 'Repeated Customers', isPercentage: true },  
  { endValue: 5, label: 'Years of Experience', isPercentage: false },
];

const CountCardsContainer = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-6 mt-16">
      {countData.map((data, index) => (
        <CountCard 
          key={index} 
          endValue={data.endValue} 
          label={data.label}  
          isprimary={ index === 3} 
          isPercentage={data.isPercentage}  
        />
      ))}
    </div>
  );
};

export default CountCardsContainer;
